module.exports = "<ul *ngIf=\"shouldShowErrors()\">\r\n  <li class=\"help-block m-b-none\" style=\"color: red!important\" *ngFor=\"let error of listOfErrors()\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i> {{error}}</li>\r\n</ul>"


//////////////////
// WEBPACK FOOTER
// D:/padriana/gorent-panel/src/app/dashboard/show-errors/show-errors.component.html
// module id = ../../../../../src/app/dashboard/show-errors/show-errors.component.html
// module chunks = main